package com.example.mystybag.login.helpers

import com.example.mystybag.common.logic.NavigatorInternetTroubleshooting
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.logic.base.ChildViewModel

fun <T : Any> ChildViewModel<T>.navigateToLoginHelp() {
    if (!PlatformHelper.isWeb) return
    navigate(NavigatorInternetTroubleshooting)
}
